<template>
<div class="container">
  <van-nav-bar fixed title="咨询解答" right-text="我的咨询"  @click-right="$utils.jump('/askListM')" v-if="userInfo!=null"/>
  <van-nav-bar fixed title="咨询解答" right-text="我要咨询"  @click-right="$utils.jump('/askNoAuth')" v-else/>
  <div class="main__body" v-if="list!=null">
    <div class="asks__list__container">
      <div class="list__item" v-for="(item,index) in list" :key="index" @click="$utils.jump(`/asksDetail/${item.id}?from=zixunjieda`)">
        <MList :item="item" type="asklist"/>
      </div>
      <div class="load__wrapper" v-if="loading==true">
        <Load />
      </div>
      <div class="list__end" v-if="page==totalPage && loading==false">
        <span>已经到底啦...</span>
      </div>
      <van-empty description="暂无内容" v-if="list.length==0 && loading==false" />
    </div>
  </div>
</div>
</template>
<script>
import MList from "@/components/MList";
import {
  mapActions
} from 'vuex'
export default {
  data() {
    return {
      page: 1,
      pageSize: 15,
      totalPage: null,
      list: null,
      loading: true,
      userInfo: null
    }
  },
  components: {
    MList
  },
  computed: {},
  created() {
    scrollTo(0, 0)

  },
  methods: {
    init() {
      this.userInfo=this.$utils.getStorage('userInfo')
      scrollTo(0, 0)
      this.list = null
      this.page = 1
      this.getList()
    },
    loadMore() {
      let {
        page,
        totalPage,
        loading
      } = this
      if (loading) {
        return false
      }
      if (totalPage != null) {
        if (page < totalPage) {
          this.page++
          this.getList();
        }
      }
    },
    async getList() {
      let self = this
      let {
        page,
        pageSize,
        list
      } = self
      self.loading = true
      let posData = {
        data: {
          page,
          pageSize
        }
      }
      if (list != null) {
        posData.loadMsg = false
      }
      let res = await this._getAskList(posData)
      self.loading = false
      if (res && res.code == 200) {
        if (list == null) {
          self.list = res.data.list
        } else {
          self.list.push(...res.data.list)
        }
        self.totalPage = res.data.totalPage
      }
    },
    ...mapActions('api', ['_getAskList'])
  }
}
</script>
<style lang="less" scoped>
.container {
    .main__body {
      margin-top: 46px;
      min-height: calc(100vh - 96px);
      padding-bottom: 50px;
    }
}
</style>
